import { Component, OnInit } from '@angular/core';
import { GlobalErrorHandler } from '../../../../services/error.handler';
import { Location } from '@angular/common';
import { AnimationOptions } from 'ngx-lottie';
import { UIModel } from '../../../../models/core/ui/ui.model';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit {

  /**
   * Gets or sets animation options for lottie.
   */
  public animationOptions: AnimationOptions = {
    path: UIModel.notFoundAltErrorAnimationUrl
  };


  constructor(
    private location: Location) { }

  public ngOnInit(): void {
    // Reset error as user should be able to navigate back
    // with this error.
    GlobalErrorHandler.isFatalError = false;
    GlobalErrorHandler.fatalError = undefined;
  }


  /**
   * Navigates back to previous page.
   */
  public navigateToPrevious(): void {
    // Move back to 2 because first page is the one that was not found.
    this.location.historyGo(-2);
  }

}
